/**
 * Detection for the Martini desktop shell (Electron).
 *
 * The shell strips the Electron token from the user-agent and appends
 * "MartiniDesktop/<version>" instead (see desktop/src/main.ts), so this is
 * the canonical way for the web app to detect it.
 */
export function isDesktopApp(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent.includes('MartiniDesktop')
}

export function buildDesktopAppUrl(pathname: string, search = ''): string {
  return `martini://${pathname.replace(/^\//, '')}${search}`
}
